import { Button, ButtonWidth, Modal } from '@nextgen-web-framework/all';
import styles from './ExceptionModal.module.scss';
import { ExceptionModalProps } from './types/propsType';

export const ExceptionModal = ({
  title,
  buttonTitle,
  description,
  onButtonClick = () => null,
}: ExceptionModalProps) => (
  <Modal headline={title} closeIcon={false} primaryButtonLabel="">
    <div className={styles['exception-modal-content']}>
      <div data-testid="description-testid">{description}</div>
      <Button buttonWidth={ButtonWidth.FULL_WIDTH} onClick={onButtonClick} title={buttonTitle} />
    </div>
  </Modal>
);
